import { render, staticRenderFns } from "./noData.vue?vue&type=template&id=34f7fabc&scoped=true&"
var script = {}
import style0 from "./noData.vue?vue&type=style&index=0&id=34f7fabc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f7fabc",
  null
  
)

export default component.exports